/* eslint-disable */
export const debug = (message: any, ...attrs: any[]) => {

    // @ts-ignore
    if((import.meta.env.debug) || window?.debug) {
        console.log(message, attrs)
    }
}
